module.exports = __webpack_public_path__ + "img/nav.91fa6e46.png";